import { render, staticRenderFns } from "./TDraftCreate.vue?vue&type=template&id=0d9338d2&"
import script from "./TDraftCreate.vue?vue&type=script&lang=js&"
export * from "./TDraftCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d9338d2')) {
      api.createRecord('0d9338d2', component.options)
    } else {
      api.reload('0d9338d2', component.options)
    }
    module.hot.accept("./TDraftCreate.vue?vue&type=template&id=0d9338d2&", function () {
      api.rerender('0d9338d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/directDebit/TDraftCreate.vue"
export default component.exports